import SearchCourse from './search-course'

export default SearchCourse
